// /pages/about.page.jsx

import React from 'react';
import { about } from '../src/about';

export function Page() {
  return (
    <div className="bg-zinc-100 dark:bg-zinc-800 p-4 mb-4 rounded-sm">
     

       <div className="max-w-screen-lg mx-auto text-zinc-900 dark:text-zinc-100">

        <b><a href="/" className="text-xl underline"> back to OceanOrb</a></b><br></br><br></br>

        <h1 className="text-xl font-semibold mb-4">About OceanOrb.org &nbsp; &nbsp; &nbsp; - &nbsp; &nbsp; &nbsp; Contact info@oceanorb.org</h1>
        
        <b className="block mb-2">{about.title1}</b>
        <p className="mb-4">{about.paragraph1}</p>
        
        <b className="block mb-2">{about.title2}</b>
        <p className="mb-4">{about.paragraph2}</p>
        
        <b className="block mb-2">{about.title3}</b>
        <p className="mb-4">{about.paragraph3}</p>
        
        <b className="block mb-2">{about.title4}</b>
        <p className="mb-4">{about.paragraph4}</p>
        
        <b className="block mb-2">{about.title5}</b>
        <p className="mb-6">{about.paragraph5}</p>
        
        <b className="block mb-2">{about.sources}</b>
        <ul className="mb-6">
          {about.dataSources.map((source, index) => (
            <li key={index} className="mb-1">{source}</li>
          ))}
        </ul>
        
        <b className="block mb-2">{about.legal1}</b>
        <b className="block mb-2">{about.legal2}</b>
        <p className="mb-4">{about.legal3}</p>
        
        <b className="block mb-2">{about.legal4}</b>
        <p className="mb-4">{about.legal5}</p>
        
        <b className="block mb-2">{about.legal6}</b>
        <p className="mb-4">{about.legal7}</p>
        
        <b className="block mb-2">{about.legal8}</b>
        <p className="mb-4">{about.legal9}</p>
        
        <b className="block mb-2">{about.legal10}</b>
        <p className="mb-4">{about.legal11}</p>
        
        <b className="block mb-2">{about.legal12}</b>
        <p>{about.legal13}</p> <br></br>

        <b><a href="/" className="text-xl underline"> back to OceanOrb</a></b>
       
      </div>
    </div>
  );
}